import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface PreferenceSection {
    id: string;
    name: string;
    icon: string;
    description: string;
}

@Component({
    selector: 'app-user-preferences-dialog',
    standalone: false,
    templateUrl: './user-preferences-dialog.component.html',
    styleUrls: ['./user-preferences-dialog.component.scss'],
})
export class UserPreferencesDialogComponent {
    /** Add new preference categories here; each id maps to a content panel in the template */
    public sections: PreferenceSection[] = [
        {
            id: 'landing-page',
            name: 'Landing Page',
            icon: 'flight_land',
            description: 'Where you land after signing in',
        },
    ];

    public activeSectionId = this.sections[0].id;
    public isDirty = false;
    public showCloseConfirm = false;

    constructor(private dialogRef: MatDialogRef<UserPreferencesDialogComponent>) {}

    public selectSection = (sectionId: string) => {
        this.activeSectionId = sectionId;
    };

    public onDirtyChange = (dirty: boolean) => {
        this.isDirty = dirty;
        if (!dirty) {
            this.showCloseConfirm = false;
        }
    };

    public attemptClose = () => {
        if (this.isDirty) {
            this.showCloseConfirm = true;
            return;
        }
        this.dialogRef.close();
    };

    public keepEditing = () => {
        this.showCloseConfirm = false;
    };

    public discardAndClose = () => {
        this.dialogRef.close();
    };
}
